import { api } from '@/api'

export interface ServiceProvider {
  id: string
  name: string
  slug: string
  description: string | null
  logo_url: string | null
  website_url: string | null
  is_active: boolean
  services_count: number
  created_at: string
}

export interface ServiceProviderOption extends ServiceProvider {
  label: string
  value: string
}

export interface ServiceProvidersFilters {
  page?: number
  [key: string]: string | number | boolean | undefined | null
}

export interface ServiceProvidersResponse {
  data: ServiceProvider[]
  meta: {
    message: string
    errors: unknown[]
  }
  pagination: {
    currentPage: number
    perPage: number
    total: number
    lastPage: number
    from: number | null
    to: number | null
  }
}

export function getServiceProvidersAction(filters: ServiceProvidersFilters = {}) {
  const params = new URLSearchParams()

  if (filters.page) {
    params.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      params.append(`filter[${key}]`, String(value))
    }
  })

  const query = params.toString()

  return api.v2.get<ServiceProvidersResponse>(`/service-providers${query ? `?${query}` : ''}`)
}
